import React from 'react';
import ReactDOM from 'react-dom';
import Root from './root.component.js';
import { of } from 'rxjs';
import singleSpaCanopy from 'single-spa-canopy';
import singleSpaReact from 'single-spa-react';

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  domElementGetter,
});

const canopyLifecycles = singleSpaCanopy({
  mainContentTransition: false,
  domElementGetter,
  featureToggles: ['timers', 'toggle_transcripts_module'],
  hotload: {
    module,
    __webpack_require__,
    dev: {
      enabled: true,
    },
  },
  overlay: {
    selectors: ['.cps-topnav-secondary'],
  },
});

export const bootstrap = [canopyLifecycles.bootstrap, reactLifecycles.bootstrap];

export const mount = [reactLifecycles.mount, canopyLifecycles.mount];

export const unmount = [reactLifecycles.unmount, canopyLifecycles.unmount];

export const unload = [canopyLifecycles.unload];

/* If the contact menu is loaded at all, it's height is 118.
 * If it is not loaded, it is up to the user to deduce that the
 * height is effectively 0.
 */
export const contactMenuHeightObs = of(118);

function domElementGetter() {
  let el = document.getElementById('contact-menu');
  if (!el) {
    el = document.createElement('div');
    el.id = 'contact-menu';
    document.body.appendChild(el);
  }

  return el;
}
